module.exports = __webpack_public_path__ + "img/L5.d9aadcf1.jpg";